import { cn } from '@nexelem/utils';
import { useTableTranslation } from '../translations';
import { useTableInfiniteQuery } from '../utils';
import type { PropsWithChildren } from 'react';
import { ScrollUpButton } from './ScrollUpButton';

type FooterProps = {
  className?: string;
  showScrollUpButton?: boolean;
};

export const Footer = ({ children, className, showScrollUpButton = true }: PropsWithChildren<FooterProps>) => {
  const { t } = useTableTranslation();
  const { dataLength, dataTotalLength } = useTableInfiniteQuery();

  return (
    <footer
      className={cn(
        'box-border flex h-15 shrink-0 items-center justify-between border-t border-border-primary bg-surface-secondary px-8',
        className,
      )}
    >
      <span className="text-s11-sb text-text-secondary-darker">
        {dataLength} {t('of')} {dataTotalLength}
      </span>
      {children}
      {showScrollUpButton && <ScrollUpButton />}
    </footer>
  );
};
